// ********* role id's ******************
export const initialAssmtName = 'Initial Assessment';
export const StatusCompleted = 'Completed';
export const CCRoleID = 2;
export const ClaimsAdminRoleID = 4;
export const ManagerRoleID = 5;
export const SAMRoleID = 6;
export const adminRoleID = 7;
export const CaseManagerRoleID = 8;
export const SupportRoleID = 9;
export const AuditorRoleID = 10;
export const AssessorRoleID = 2; // Both cc and Assesor have same roleID
export const ResourceSpecialistRoleID = 12;
export const DialerAdminRoleID = 13;
export const ProdOpsRoleID = 14;
export const MemberRoleID = 15;
// ********* role id's ******************

// ********* page name's ******************
export const workspace = 'workspace';
export const memberinfo = 'memberinfo';
export const careplanAssessment = 'careplanAssessment';
export const addmember = 'addmember';
export const referralmanagement = 'referralmanagement';
export const assignmentrulesconfigure = 'assignmentrulesconfigure';
export const organization = 'organization';
export const addorganization = 'addorganization';
export const addorganizationedit = 'addorganizationedit';
export const orgusers = 'orgusers';
export const addorguser = 'addorguser';
export const orgusersedit = 'orgusersedit';
export const assessconfigure = 'assessconfigure';
export const applicatoinflow = 'applicatoinflow';
export const reports = 'reports';
export const addassessment = 'addassessment';
export const vendorinvoice = 'vendorinvoice';
export const vendorpayrules = 'vendorpayrules';
export const cohortbuilder = 'cohortbuilder';
export const programconfig = 'programconfig';
export const billing = 'billing';
export const feeschedule = 'feeschedule';
export const skillSetConfiguration = 'skillSetConfiguration';
export const dialerDashboard = 'dialerDashboard';
export const programs = 'programs';
export const bannernotifications = 'bannernotifications';
export const expansionrequest = 'expansionrequest';
export const utcreferrals = 'utcreferrals';
export const header = 'header';
export const notifications = 'notifications';
export const cacheupdate = 'cacheupdate';
export const clientinvoice = 'clientinvoice';
export const dualvendorinvoice = 'dualvendorinvoice';
export const daworkspace = 'daworkspace';
export const spworkspace = 'spworkspace';
export const billingreconcile = 'billingreconcile';
export const common = 'common';
export const home = 'home';
export const newdashboard = 'newdashboard';
export const agentskills = 'agentskills';
export const queuedetails = 'queuedetails';
export const supervisordashboard = 'supervisordashboard';
export const clientinvoiceItems = 'clientinvoiceItems';
export const cohorts = 'cohorts';
export const cohortconfig = 'cohortconfig';
export const surveydashboard = 'surveydashboard';
export const reconcilefile = 'reconcilefile';
export const qaAuditQuestionaryForm = 'QaAuditQuestionaryForm';
export const careplan = 'careplan';
export const solution = 'solution';
// ********* page name's ******************
